import React from "react";
import "./styles.css";

const About: React.FC = () => {
  return (
    <div className="about">
      <div className="headerBackground"></div>
      <h1>ACERCA DE JUST DANGER </h1>
      <img src="https://res.cloudinary.com/ddoltb8nf/image/upload/v1662075065/just/Logo-just-Danger_avb1dy.png"></img>
      <p>
        Somos distribuidores de los mejores laboratorios de complementos
        nutricionales de Estados Unidos de norte América y que ya han sido
        aprobados por la FDA Nacimos debido a tu necesidad de comprar todos tus
        complementos en un solo lugar que te brinda los siguientes beneficios: <br></br> 1.
        Precio de mayoreo a partir de 5 productos pudiendo ser estos todos
        diferentes y sin importar el precio unitario ni el importe total <br></br> 2.
        Variedad de productos desde quemadores hasta potenciadores, desde barras
        energéticas hasta proteínas de carne <br></br> 3. Entrega en tu lugar de
        preferencia en no más de 24 horas <br></br> 4. Con la filosofía de negocio “si no
        lo tengo lo consigo por y para ti” Por el momento entregamos
        presencialmente en el área metropolitana y parar pedidos en otra ciudad
        se embarca por Estafeta.
      </p>
    </div>
  );
};

export default About;
